export const ALCATEL = {
  id: "alcatel",
  name: "ALCATEL",
  imageFolder: "/alcatel",
  tagline: {
    pt: "Alcatel-Lucent Enterprise — Centrais telefónicas, telefones IP e soluções DECT.",
    en: "Alcatel-Lucent Enterprise — PBX systems, IP phones and DECT solutions.",
    es: "Alcatel-Lucent Enterprise — Centralitas, teléfonos IP y soluciones DECT.",
  },
  color: "#005eb8",
  theme: {
    bgGradient: "from-[#e8f1fa] via-[#d8e8f5] to-[#dfecf6]",
    blob1: "bg-sky-300/30",
    blob2: "bg-blue-200/40",
    overlineText: "text-sky-700",
    pillarPill: "border-sky-400 text-sky-700",
    segmentHover: "hover:border-sky-400",
    tabHover: "hover:border-sky-400 hover:text-sky-700",
    ctaPrimary:
      "bg-sky-600 hover:bg-sky-700 shadow-sky-600/25 hover:shadow-sky-600/40",
    ctaOutline: "border-sky-400 text-sky-700 hover:bg-sky-50",
    productHover: "hover:border-sky-400",
    productQuoteCta: "border-sky-400 text-sky-700 hover:bg-sky-50",
    productBadge: "text-sky-700",
    productPreviewPill: "text-sky-700",
    whyPanel: "border-sky-200 from-sky-50 to-white",
    whyItemBorder: "border-sky-100",
    whyCheck: "text-sky-600",
    modalHeaderBg: "from-sky-50 via-[#d8e8f5] to-blue-50",
    modalBrandBadge: "border-sky-200 text-sky-700",
    modalInputFocus: "focus:border-sky-500 focus:ring-sky-500/20",
    modalSubmit:
      "bg-sky-600 hover:bg-sky-700 shadow-sky-600/25 hover:shadow-sky-600/40",
  },
  pillars: {
    pt: ["PABX", "IP Phones", "DECT", "Headsets"],
    en: ["PBX", "IP Phones", "DECT", "Headsets"],
    es: ["PABX", "Teléfonos IP", "DECT", "Auriculares"],
  },
  segments: {
    pt: [
      { name: "Escritórios", desc: "Centrais IP e telefones corporativos para empresas de todos os tamanhos." },
      { name: "Hotelaria", desc: "Sistemas telefónicos para quartos e recepção com integração PMS." },
      { name: "Call-Centers", desc: "Telefones e headsets para operadores de alta performance." },
      { name: "Indústria", desc: "DECT robusto IP65 para fábricas, armazéns e logística." },
      { name: "Saúde", desc: "Comunicação hospitalar com DECT e IP phones médicos." },
      { name: "Retalho", desc: "Rede telefónica multi-loja com gestão central." },
    ],
    en: [
      { name: "Offices", desc: "IP PBX and business phones for companies of all sizes." },
      { name: "Hospitality", desc: "Room and reception phones with PMS integration." },
      { name: "Call Centers", desc: "Phones and headsets for high-performance operators." },
      { name: "Industry", desc: "Rugged IP65 DECT for factories, warehouses and logistics." },
      { name: "Healthcare", desc: "Hospital communication with DECT and medical IP phones." },
      { name: "Retail", desc: "Multi-store telephony with central management." },
    ],
    es: [
      { name: "Oficinas", desc: "Centralitas IP y teléfonos empresariales para empresas de todos los tamaños." },
      { name: "Hotelería", desc: "Teléfonos de habitación y recepción con integración PMS." },
      { name: "Call Centers", desc: "Teléfonos y auriculares para operadores de alto rendimiento." },
      { name: "Industria", desc: "DECT robusto IP65 para fábricas, almacenes y logística." },
      { name: "Salud", desc: "Comunicación hospitalaria con DECT y teléfonos IP médicos." },
      { name: "Retail", desc: "Telefonía multi-tienda con gestión centralizada." },
    ],
  },
  why: {
    pt: {
      title: "Porquê escolher a Alcatel-Lucent?",
      items: [
        "Líder europeu em comunicações empresariais",
        "Centrais escaláveis de 10 a 100.000 utilizadores",
        "Integração com Microsoft Teams",
        "Segurança empresarial e criptografia SRTP",
        "DECT robusto para ambientes industriais",
        "Assistência e configuração em Angola",
      ],
    },
    en: {
      title: "Why choose Alcatel-Lucent?",
      items: [
        "European leader in enterprise communications",
        "Scalable PBX from 10 to 100,000 users",
        "Microsoft Teams integration",
        "Enterprise security and SRTP encryption",
        "Rugged DECT for industrial environments",
        "Local support and configuration in Angola",
      ],
    },
    es: {
      title: "¿Por qué elegir Alcatel-Lucent?",
      items: [
        "Líder europeo en comunicaciones empresariales",
        "Centralitas escalables de 10 a 100.000 usuarios",
        "Integración con Microsoft Teams",
        "Seguridad empresarial y cifrado SRTP",
        "DECT robusto para entornos industriales",
        "Soporte y configuración local en Angola",
      ],
    },
  },
  groups: [
    {
      id: "pabx",
      icon: "phone",
      featured: true,
      title: {
        pt: "PABX — Centrais OmniPCX",
        en: "PBX — OmniPCX Systems",
        es: "PABX — Centralitas OmniPCX",
      },
      description: {
        pt: "Centrais telefónicas híbridas, IP e cloud Alcatel-Lucent OmniPCX — do pequeno escritório à grande empresa, com integração com Microsoft Teams e Rainbow UCaaS.",
        en: "Hybrid, IP and cloud Alcatel-Lucent OmniPCX PBX — from small office to large enterprise, with Microsoft Teams and Rainbow UCaaS integration.",
        es: "Centralitas híbridas, IP y cloud Alcatel-Lucent OmniPCX — de la oficina pequeña a la gran empresa, con integración Microsoft Teams y Rainbow UCaaS.",
      },
      highlights: {
        pt: [
          "Híbrida, IP pura e cloud",
          "Escalável de 10 a 100.000 utilizadores",
          "Integração Microsoft Teams",
          "SIP trunking e ligações analógicas/digitais",
          "Voicemail e IVR integrados",
          "Rainbow UCaaS — colaboração e chat",
        ],
        en: [
          "Hybrid, pure-IP and cloud",
          "Scalable from 10 to 100,000 users",
          "Microsoft Teams integration",
          "SIP trunking + analog/digital lines",
          "Integrated voicemail and IVR",
          "Rainbow UCaaS — collaboration and chat",
        ],
        es: [
          "Híbrida, IP pura y cloud",
          "Escalable de 10 a 100.000 usuarios",
          "Integración Microsoft Teams",
          "SIP trunking + líneas analógicas/digitales",
          "Voicemail e IVR integrados",
          "Rainbow UCaaS — colaboración y chat",
        ],
      },
      products: [
        {
          slug: "omnipcx-office-rce",
          pt: "OmniPCX Office RCE — Central híbrida para PME até 200 utilizadores",
          en: "OmniPCX Office RCE — Hybrid PBX for SMBs up to 200 users",
          es: "OmniPCX Office RCE — Centralita híbrida para pymes hasta 200 usuarios",
        },
        {
          slug: "omnipcx-enterprise",
          pt: "OmniPCX Enterprise — Central IP para grandes empresas (até 100.000 users)",
          en: "OmniPCX Enterprise — IP PBX for large enterprises (up to 100,000 users)",
          es: "OmniPCX Enterprise — Centralita IP para grandes empresas (hasta 100.000 usuarios)",
        },
        {
          slug: "omnipcx-rainbow",
          pt: "Rainbow UCaaS — Colaboração cloud com voz, chat e video",
          en: "Rainbow UCaaS — Cloud collaboration with voice, chat and video",
          es: "Rainbow UCaaS — Colaboración cloud con voz, chat y video",
        },
      ],
    },
    {
      id: "ip-phones",
      icon: "phone",
      title: {
        pt: "Telefones IP — Série 8000",
        en: "IP Phones — 8000 Series",
        es: "Teléfonos IP — Serie 8000",
      },
      description: {
        pt: "Gama completa de telefones IP SIP — do modelo entrada 8008 ao topo executivo Myriad, todos com PoE, HD voice e gestão centralizada.",
        en: "Full range of SIP IP phones — from entry-level 8008 to executive flagship Myriad, all with PoE, HD voice and central management.",
        es: "Gama completa de teléfonos SIP — del básico 8008 al flagship ejecutivo Myriad, todos con PoE, HD voice y gestión centralizada.",
      },
      highlights: {
        pt: [
          "SIP nativo e HD voice",
          "PoE (Power over Ethernet)",
          "Display LCD color ou monocromático",
          "Teclas programáveis BLF",
          "Criptografia SRTP",
          "Gestão central via OmniPCX",
        ],
        en: [
          "Native SIP and HD voice",
          "PoE (Power over Ethernet)",
          "Color or monochrome LCD display",
          "Programmable BLF keys",
          "SRTP encryption",
          "Central management via OmniPCX",
        ],
        es: [
          "SIP nativo y HD voice",
          "PoE (Power over Ethernet)",
          "Pantalla LCD color o monocromática",
          "Teclas programables BLF",
          "Cifrado SRTP",
          "Gestión central via OmniPCX",
        ],
      },
      products: [
        {
          slug: "alcatel-8008",
          pt: "Myriad 8008 — Telefone IP SIP entrada de gama",
          en: "Myriad 8008 — Entry-level SIP IP phone",
          es: "Myriad 8008 — Teléfono SIP de gama básica",
        },
        {
          slug: "alcatel-8018",
          pt: "Myriad 8018 — Telefone IP com display color e 8 teclas BLF",
          en: "Myriad 8018 — IP phone with color display and 8 BLF keys",
          es: "Myriad 8018 — Teléfono IP con pantalla color y 8 teclas BLF",
        },
        {
          slug: "alcatel-8028s",
          pt: "Myriad 8028s — Telefone IP gestor com teclas programáveis avançadas",
          en: "Myriad 8028s — Manager IP phone with advanced programmable keys",
          es: "Myriad 8028s — Teléfono IP gerencial con teclas programables avanzadas",
        },
        {
          slug: "alcatel-myriad",
          pt: "Myriad Premium — Telefone IP executivo com ecrã táctil",
          en: "Myriad Premium — Executive IP phone with touch screen",
          es: "Myriad Premium — Teléfono IP ejecutivo con pantalla táctil",
        },
      ],
    },
    {
      id: "dect",
      icon: "antenna",
      title: {
        pt: "DECT — Telefones Sem Fios",
        en: "DECT — Cordless Phones",
        es: "DECT — Teléfonos Inalámbricos",
      },
      description: {
        pt: "Soluções DECT IP para mobilidade interna — handsets comerciais e industriais IP65 para hospitais, fábricas, armazéns e hotéis.",
        en: "IP DECT solutions for internal mobility — commercial and industrial IP65 handsets for hospitals, factories, warehouses and hotels.",
        es: "Soluciones DECT IP para movilidad interna — handsets comerciales e industriales IP65 para hospitales, fábricas, almacenes y hoteles.",
      },
      products: [
        {
          slug: "alcatel-dect-8232",
          pt: "8232 DECT — Handset DECT comercial com display color",
          en: "8232 DECT — Commercial DECT handset with color display",
          es: "8232 DECT — Handset DECT comercial con pantalla color",
        },
        {
          slug: "alcatel-dect-8262",
          pt: "8262 DECT — Handset industrial IP65 com Push-to-Talk",
          en: "8262 DECT — Rugged IP65 industrial handset with Push-to-Talk",
          es: "8262 DECT — Handset industrial IP65 con Push-to-Talk",
        },
      ],
    },
    {
      id: "headsets",
      icon: "headphones",
      title: {
        pt: "Headsets — Call-Center",
        en: "Headsets — Call-Center",
        es: "Auriculares — Call-Center",
      },
      description: {
        pt: "Headsets profissionais para operadores de call-center — cancelamento de ruído, conforto e compatibilidade com todos os telefones IP Alcatel-Lucent.",
        en: "Professional call-center headsets — noise cancellation, comfort and compatibility with all Alcatel-Lucent IP phones.",
        es: "Auriculares profesionales para call-center — cancelación de ruido, confort y compatibilidad con todos los teléfonos IP Alcatel-Lucent.",
      },
      products: [
        {
          slug: "alcatel-ip-headset",
          pt: "IP Headset — Auricular mono com microfone noise-cancelling",
          en: "IP Headset — Mono headset with noise-cancelling microphone",
          es: "IP Headset — Auricular mono con micrófono noise-cancelling",
        },
      ],
    },
  ],
};
